/**
 * Mixin para el flujo de Industry con jerarquía (padre > hijo > nieto).
 * Expande selecciones de padres/hijos a solo ids de nietos (hojas) para categories_industry / categories_not_industry.
 */
export default {
  methods: {
    /**
     * Recorre el árbol y devuelve el nodo cuyo id coincide.
     */
    _findNodeById(nodes, id) {
      if (!nodes || !Array.isArray(nodes)) return null
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === id) return nodes[i]
        const found = this._findNodeById(nodes[i].children, id)
        if (found) return found
      }
      return null
    },

    /**
     * De un nodo, recoge todos los ids de nietos (hojas: tienen id y no tienen children).
     */
    _collectLeafIdsFromNode(node) {
      if (!node) return []
      if (node.children && node.children.length > 0) {
        return node.children.reduce((acc, child) => acc.concat(this._collectLeafIdsFromNode(child)), [])
      }
      if (node.id != null && String(node.id).indexOf('branch-') !== 0) {
        return [String(node.id)]
      }
      return []
    },

    /**
     * Dado un array de ids seleccionados (pueden ser branch-* o ids de nietos)
     * y el árbol de categorías, devuelve solo los ids de los nietos (hojas).
     * @param {string[]} selectedIds - ids emitidos por el treeselect
     * @param {Array} tree - árbol (ej. categories_google_all.data)
     * @returns {string[]} ids de nietos únicos
     */
    getLeafIdsFromIndustrySelection(selectedIds, tree) {
      if (!selectedIds || !Array.isArray(selectedIds)) return []
      if (!tree || !Array.isArray(tree)) return selectedIds.filter(Boolean)
      const result = []
      for (let i = 0; i < selectedIds.length; i++) {
        const id = selectedIds[i]
        if (id == null || id === '') continue
        const idStr = String(id)
        if (idStr.indexOf('branch-') === 0) {
          const node = this._findNodeById(tree, idStr)
          if (node) result.push(...this._collectLeafIdsFromNode(node))
        } else {
          result.push(idStr)
        }
      }
      return [...new Set(result)]
    }
  }
}